import { gsap } from "gsap";

// ---------------- Появление элемента
/*
	1) Увеличение высоты контейнера
	2) Появление контента
	3) Установка высоты контейнера в "auto"

	Опции: 
	 - duration (число) - длительность анимации, 
	 - ease (строка) - функция ease
*/
type ShowElementOptions = {
  duration?: number;
  ease?: string;
  extraHeight?: number;
};
export const showElement = (
  container: HTMLElement,
  options: ShowElementOptions = {}
) => {
  const content = container.firstElementChild as HTMLElement | null;
  if (!content) return null;

  const { duration = 0.2, ease = "elastic.out(0.3, 0.9)", extraHeight = 24 } = options;
  const contentHeight = content.offsetHeight + extraHeight;

  gsap.set(container, { height: 0, overflow: "hidden" });
  gsap.set(content, { opacity: 0 });

  const timeline = gsap.timeline();

  timeline.to(container, {
    height: contentHeight,
    duration,
    ease,
  });

  timeline.to(content, {
    opacity: 1,
    duration: 0.2,
    ease: "none",
  });

  if (extraHeight > 0) {
    timeline.set(container, { height: contentHeight });
  } else {
    timeline.set(container, { height: "auto" });
  }

  return timeline;
};
